import { BaseFormScaffoldState } from "../FormScaffold.types";

export function hasChangedData<T extends BaseFormScaffoldState>(newData: T, state: T) {
    return JSON.stringify(newData) !== JSON.stringify(state);
}
